import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Button, Divider, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import history from '../history';
import { signOut } from '../../actions';
import { useDispatch} from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },

    title: {
        flexGrow: 1,
    },
}));

const Navbar = () => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

    const handleMenu = (event) => {

        setAnchorEl(event.currentTarget);

    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (pathName) => {
        setAnchorEl(null);
        history.push(pathName);
    }

    const menuItems = [
        {
            menuTitle: 'WordMarket',
            pageURL: '/dashBoard'
        },
        {
            menuTitle: 'Leader Board',
            pageURL: '/leaderBoard'
        },
        {
            menuTitle: 'Portfolio',
            pageURL: '/portfolio'
        },
        {
            menuTitle: 'About',
            pageURL: '/about'
        },
        {
            menuTitle: 'Study Corner',
            pageURL: '/studyCorner'
        }
    ]


    return (
        <div className={classes.root}>

            <AppBar position="static">
                <Toolbar>

                    {!isMobile ? null :

                        <Button className={classes.title} onClick={() => handleClick("/dashBoard")}>
                            WordBank
                       </Button>}


                    {isMobile ? (

                        <React.Fragment>
                            <IconButton edge="end" className={classes.menuButton} onClick={handleMenu}
                                color="inherit" aria-label="menu">
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'center',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                getContentAnchorEl={null}
                                open={open}
                                onClose={handleClose}
                            >
                                {menuItems.map(menuItem => (
                                    <MenuItem key={menuItem.menuTitle} onClick={() => { handleClick(menuItem.pageURL) }}>{menuItem.menuTitle}</MenuItem>

                                ))}
                                <Divider />
                                <MenuItem onClick={() => { handleClick();dispatch(signOut())}}>Sign Out</MenuItem>
                            </Menu>
                        </React.Fragment>


                    ) : (


                            <React.Fragment>
                                <Grid container justify="space-between" alignItems="center">
                                    <Grid item>
                                        <Button className={classes.title} onClick={() => handleClick("/portfolio")}>
                                            Portfolio
                                            </Button>
                                    </Grid>
                                    <Grid item >
                                        <Button className={classes.title} onClick={() => handleClick("/dashBoard")}>
                                            WordMarket
                                            </Button>
                                    </Grid>
                                    <Grid item >
                                        <Button className={classes.title} onClick={() => handleClick("/leaderBoard")}>
                                            LeaderBoard
                                            </Button>
                                    </Grid>
                                    
                                    <Grid item >
                                        <Button className={classes.title} onClick={() => handleClick("/studyCorner")}>
                                            Study Corner
                                            </Button>
                                    </Grid>
                                    <Grid item >
                                        <Button className={classes.title} onClick={() => handleClick("/about")}>
                                            About
                                            </Button>
                                    </Grid>


                                    <Grid item >
                                        <IconButton edge="end" className={classes.menuButton} onClick={handleMenu}
                                            color="inherit" aria-label="menuLarge">
                                            <AccountCircleIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>






                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'center',
                                        horizontal: 'center',
                                    }}
                                    getContentAnchorEl={null}

                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}

                                    open={open}
                                    onClose={handleClose}
                                >

                                    <MenuItem onClick={() => { handleClick(); dispatch(signOut()) }}>Sign Out</MenuItem>
                                </Menu>
                            </React.Fragment>
                        )
                    }

                </Toolbar>
            </AppBar>

        </div >
    );
}

export default Navbar;